import { useRef } from 'react';
import './Feedback.css';

const TOAST_ICONS = {
    success: '✓', // ✓
    error: '✕',   // ✕
    info: 'ℹ',    // ℹ
};

/**
 * Toast notification -- the in-page replacement for window.alert() on manual
 * saves and other one-shot outcomes.
 *
 * Pair with the useToast() hook, which owns the show/auto-hide timing:
 *   const { toast, showToast } = useToast();
 *   showToast(t('chapter.changesSaved'));                  // success
 *   showToast(t('chapter.errors.saveFailed'), 'error');    // failure
 *   ...
 *   <Toast toast={toast} />
 *
 * @param {?{message: string, variant: string}} toast  null once hidden.
 */
function Toast({ toast }) {
    // The node stays mounted so it can fade OUT; without holding on to the last
    // message the text would blank instantly at the start of that fade.
    const lastShownRef = useRef(null);
    if (toast) lastShownRef.current = toast;

    const shown = toast || lastShownRef.current;
    const variant = shown?.variant || 'success';

    return (
        <div
            className={`mc-toast mc-toast--${variant}${toast ? ' show' : ''}`}
            role="status"
            aria-live="polite"
        >
            <span className="mc-toast-icon" aria-hidden="true">
                {TOAST_ICONS[variant] || TOAST_ICONS.info}
            </span>
            <span className="mc-toast-message">{shown?.message || ''}</span>
        </div>
    );
}

export default Toast;
